import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchManagedProduct: DocumentNode = gql`
  query FetchManagedProduct($storyId: String!, $version: String!, $relations: String) {
    fetchManagedProductContent(relations: $relations, storyId: $storyId, version: $version) {
      ... on ManagedProductContent {
        rels
        story {
          slug
          content {
            name
            checkoutSurveys
            confirmationFeaturesList
            confirmationVideo
            productLogo {
              filename
            }
            nfrPlanSet
            subscriptionPlanSet
            productDownloads
          }
        }
      }
    }
  }
`

export default fetchManagedProduct
